import React from 'react';
import {
    Plus, Save, X, Loader2,
    User, Globe, Settings, FileText
} from 'lucide-react';
import { FormField, TextInput } from './WhatsappConfigComponents';

export default function WhatsappConfigForm({
    formData,
    isEditing,
    isSaving,
    onChange,
    onSave,
    onCancel,
}) {
    const field = (key, label, icon, placeholder, type = 'text') => (
        <FormField label={label} icon={icon}>
            <TextInput
                value={formData[key] || ''}
                onChange={val => onChange(key, val)}
                placeholder={placeholder}
                disabled={isSaving}
                type={type}
            />
        </FormField>
    );

    return (
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between mb-8">
                <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-emerald-600/20 rounded-xl flex items-center justify-center">
                        <Plus className="w-6 h-6 text-emerald-400" />
                    </div>
                    <h3 className="text-2xl font-semibold">
                        {isEditing
                            ? 'Edit WhatsApp Configuration'
                            : 'Create WhatsApp Configuration'}
                    </h3>
                </div>

                {isEditing && (
                    <button
                        onClick={onCancel}
                        className="flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-xl transition-all"
                    >
                        <X className="w-5 h-5" />
                        <span>Cancel Edit</span>
                    </button>
                )}
            </div>

            {/* Fields Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {field('appName', 'App Name *', User, 'Enter app name...')}
                {field(
                    'whatsappUrl',
                    'WhatsApp URL *',
                    Globe,
                    'https://api.whatsapp-provider.com/send',
                    'url'
                )}
                {field('username', 'Username *', User, 'Enter username...')}
                {field(
                    'whatsapp_vendor_name',
                    'Vendor Name *',
                    Settings,
                    'Enter vendor name...'
                )}
                {field(
                    'notification_email',
                    'Manager Notification Email *',
                    Settings,
                    'Enter email...',
                    'email'
                )}
            </div>

            {/* Config Type */}
            <div className="mt-6">
                <FormField label="Configuration Type *" icon={FileText}>
                    <select
                        value={formData.whatsapp_config_type || ''}
                        onChange={e =>
                            onChange('whatsapp_config_type', e.target.value)
                        }
                        disabled={isSaving}
                        className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-emerald-500/50 transition-all"
                    >
                        <option value="">Select configuration type...</option>
                        <option value="BULK">BULK</option>
                        <option value="SINGLE">SINGLE</option>
                    </select>
                </FormField>
            </div>

            {/* Save Button */}
            <button
                onClick={onSave}
                disabled={isSaving}
                className="w-full mt-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50 transform hover:scale-[1.02] transition-all duration-300 bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 hover:from-emerald-700 hover:via-teal-700 hover:to-cyan-700 group relative overflow-hidden"
            >
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

                {isSaving ? (
                    <span className="flex items-center justify-center space-x-3 text-white relative z-10">
                        <Loader2 className="w-6 h-6 animate-spin" />
                        <span>{isEditing ? 'Updating...' : 'Saving...'}</span>
                    </span>
                ) : (
                    <span className="flex items-center justify-center space-x-3 text-white relative z-10">
                        <Save className="w-6 h-6" />
                        <span>
                            {isEditing
                                ? 'Update Configuration'
                                : 'Save Configuration'}
                        </span>
                    </span>
                )}
            </button>
        </div>
    );
}